export default __webpack_public_path__ + "05c7e93d51bc965206c8c18120da7957.png";